import React, { useEffect } from "react";
import MainLayout from "../../../layout";
import { TextView } from "../../../components/view-form-components/text-view";
import { ImageView } from "../../../components/view-form-components/image.view";
import ResetPasswordModal from "../../../components/modal/reset-password-modal";
import { useState } from "react";
import CommentsComponent from "../../../components/comments/comments";
import FileCommentComponent from "../../../components/comments/file-comment";
import { Link, useNavigate, useParams } from "react-router-dom";
import DeleteModal from "../../../components/modal/delete-modal";
import { api } from "../../../redux/apis/api";
import { useRole } from "../../../context/role/RoleContext";
import ShareModal from "../../../components/modal/share-modal";

const ReadUsers = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useRole();
  const permission = state?.role?.employee;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [openResetPassowrd, setOpenResetPassowrd] = useState(false);
  const [shareModalShow, setShareModalShow] = useState(false);

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/ffadmin/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteFnc = (id) => {
    api
      .post(`/ffadmin/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate("/admin/users/list");
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
      />
      <ResetPasswordModal
        id={params?.id}
        isOpen={openResetPassowrd}
        onClose={() => setOpenResetPassowrd(false)}
      />
      <ShareModal
        isOpen={shareModalShow}
        onClose={() => {
          setShareModalShow(false);
        }}
        moduleName="employee"
        modulelabel="employee"
      />
      <section className="h-full overflow-auto px-3">
        <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <h2 className="text-xl font-semibold capitalize">
            Admin Users - view
          </h2>
          <div className="flex gap-3 items-center">
            {permission?.write && (
              <button
                onClick={() => {
                  setShareModalShow(true);
                }}
                className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
              >
                share
              </button>
            )}
            {permission?.write && (
              <Link
                className="px-4 py-2 bg-blue-600 text-white rounded"
                to={`/admin/users/edit/${params?.id}`}
              >
                edit
              </Link>
            )}
            {permission?.write && (
              <button
                onClick={() => setOpenResetPassowrd(true)}
                className="px-4 py-1 bg-white border-[2px] border-primary text-primary rounded"
              >
                Reset password
              </button>
            )}
            {permission?.write && (
              <button
                onClick={() => {
                  setdeleteModalShow(true);
                }}
                className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
              >
                Delete
              </button>
            )}
          </div>
        </div>
        <section className="w-full max-w-[40rem]"></section>
        <ImageView label={"profile picture"} value={data?.profile_picture} />
        <TextView label={"Name"} value={data?.name} />
        <TextView label={"Email"} value={data?.email} />
        <TextView label={"phone_number"} value={data?.phone_number} />
        <TextView
          label={"office_phone_number"}
          value={data?.office_phone_number}
        />
        <TextView label={"gender"} value={data?.gender} />
        <TextView label={"marital_status"} value={data?.marital_status} />
        <TextView label={"current address"} value={data?.current_address} />
        <TextView label={"permanent_address"} value={data?.permanent_address} />
        <TextView label={"Role"} value={data?.role?.name} />
        <TextView label={"Designation"} value={data?.designation?.name} />
        <TextView label={"Department"} value={data?.department?.name} />
        <TextView
          label={"emergency_contact_number"}
          value={data?.emergency_contact_number}
        />
        <TextView
          label={"emergency_contact_name"}
          value={data?.emergency_contact_name}
        />
        <TextView
          label={"emergency_contact_relation"}
          value={data?.emergency_contact_relation}
        />
        <TextView label={"pan_number"} value={data?.pan_number} />
        <TextView label={"aadhar_number"} value={data?.aadhar_number} />
        <TextView
          label={"bank_account_number"}
          value={data?.bank_account_number}
        />
        <TextView label={"bank_ifsc_code"} value={data?.bank_ifsc_code} />
        <TextView label={"bank_name"} value={data?.bank_name} />
        <TextView
          label={"bank_account_holder_name"}
          value={data?.bank_account_holder_name}
        />

        <CommentsComponent tableName={"ffAdminUsers"} viewId={params?.id} />
        <FileCommentComponent tableName={"ffAdminUsers"} viewId={params?.id} />
      </section>
    </MainLayout>
  );
};

export default ReadUsers;
